exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".adduser-modal{\r\n\twidth:80%;\r\n\theight:60%;\r\n\tmargin-left:18%;\r\n\tpadding:2px 2px 2px 2px;\r\n\r\n}\r\nhr{\r\n  height: 1px;\r\n  background-color: #A9A9A9;\r\n}\r\nh6{\r\n  font-weight: bold;\r\n  color: #007b85;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-users/view-user/view-user.component.css
// module id = 462
// module chunks = 1